import Request from '@/jslib/dk-axios'

export const slideshowList = (data) => {
  return Request({
    url: 'Carousel',
    method: 'GET',
    params: data,
  })
}

export const addSlideshow = (data) => {
  return Request({
    url: 'Carousel',
    method: 'POST',
    data,
  })
}

export const editSlideshow = (data) => {
  return Request({
    url: `Carousel/${data.uuid}`,
    method: 'PUT',
    data,
  })
}

export const delSlideshow = (data) => {
  return Request({
    url: `Carousel/${data.uuid}`,
    method: 'DELETE',
    data,
  })
}

export const slideshowDetail = (data) => {
  return Request({
    url: `Carousel/${data.uuid}`,
    method: 'GET',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/slideshow.js